/* @ngInject */
const local = (

) => {
  const self = {}

  return self
}

export default local



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/movement/services/local.service.js